import PageContainer from 'components/PageContainer';
import styled from 'styled-components/native';

export const CustomPageContainer = styled(PageContainer)`
  padding: 0px;
`;

export const Content = styled.View`
  padding: 0px 16px 16px;
`;

export const BackButtonContainer = styled.View`
  padding: 16px 16px 0px;
`;
